import Animate from "./js/modules/animate";

function loadMore() {
    const button = document.querySelector("[data-load-more-button]");
    const feed = document.querySelector("[data-load-more-feed]");
    if (!button || !feed) return;

    const loadingText = button.dataset.loadingText;
    const originalText = button.innerHTML;
    const maxPages = button.dataset.maxPages;
    const actionName = button.dataset.action;
    const loadMoreOn = button.dataset.loadMoreOn;

    function loadMoreHandler() {
        button.innerHTML = loadingText;
        button.setAttribute("disabled", true);

        //loadMoreData is variable from wp_localize_script in functions.php
        const url = new URL(loadMoreData.url);
        url.searchParams.set("action", actionName);
        url.searchParams.set("query", loadMoreData.query);
        url.searchParams.set("post_type", loadMoreData.post_type);
        url.searchParams.set("current_page", button.dataset.currentPage);
        
        fetch(url.href)
            .then((response) => {
                response.json().then((data) => {
                    feed.innerHTML += data.data;
                    button.dataset.currentPage++;
                    Animate();
                    //Remove Button
                    if (Number(button.dataset.currentPage) >= Number(maxPages)) {
                        button.parentElement.remove();
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                button.innerHTML = originalText;
                button.removeAttribute("disabled");
            });
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                loadMoreHandler();
            }
        });
    });

    if (loadMoreOn === "view") {
        observer.observe(button);
    } else {
        button.onclick = () => {
            loadMoreHandler();
        };
    }
}

loadMore();
